import { render } from "./QuemSomos3.vue?vue&type=template&id=3ec8bcda"
import script from "./QuemSomos3.vue?vue&type=script&lang=js"
export * from "./QuemSomos3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__